// Small, dependency-free helpers for the "local time" widget.

// UTC offset of `timeZone` at `date`, in minutes (e.g. Africa/Addis_Ababa -> 180).
export function tzOffsetMinutes(date, timeZone) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).formatToParts(date);
    const get = (type) => Number(parts.find((p) => p.type === type).value);
    const asUtc = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
    return Math.round((asUtc - Math.floor(date.getTime() / 1000) * 1000) / 60000);
}

// "14:32" in the given zone.
export function formatClock(date, timeZone) {
    return new Intl.DateTimeFormat('en-GB', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).format(date);
}

// "UTC+3", "UTC-4", "UTC+5:30"
export function formatUtcOffset(date, timeZone) {
    const minutes = tzOffsetMinutes(date, timeZone);
    const sign = minutes < 0 ? '-' : '+';
    const abs = Math.abs(minutes);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    return `UTC${sign}${h}${m ? `:${String(m).padStart(2, '0')}` : ''}`;
}

// How the target zone compares with the visitor's: "3 hours ahead of you",
// "the same time as you", "2½ hours behind you".
export function describeDifference(date, targetZone, visitorZone) {
    const diff = tzOffsetMinutes(date, targetZone) - tzOffsetMinutes(date, visitorZone);
    if (diff === 0) return 'the same time as you';
    const hours = Math.abs(diff) / 60;
    const whole = Math.floor(hours);
    const half = hours - whole;
    const text = half === 0 ? `${whole}` : half === 0.5 ? `${whole || ''}½` : hours.toFixed(2).replace(/0+$/, '');
    const unit = hours === 1 ? 'hour' : 'hours';
    return `${text} ${unit} ${diff > 0 ? 'ahead of' : 'behind'} you`;
}
